interface IProps {
  stroke?: string
  fill?: string
}

export default function IconThreeDot({ fill = '#14448C' }: IProps) {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.00008 6.66699C3.26675 6.66699 2.66675 7.26699 2.66675 8.00033C2.66675 8.73366 3.26675 9.33366 4.00008 9.33366C4.73341 9.33366 5.33341 8.73366 5.33341 8.00033C5.33341 7.26699 4.73341 6.66699 4.00008 6.66699ZM12.0001 6.66699C11.2667 6.66699 10.6667 7.26699 10.6667 8.00033C10.6667 8.73366 11.2667 9.33366 12.0001 9.33366C12.7334 9.33366 13.3334 8.73366 13.3334 8.00033C13.3334 7.26699 12.7334 6.66699 12.0001 6.66699ZM8.00008 6.66699C7.26675 6.66699 6.66675 7.26699 6.66675 8.00033C6.66675 8.73366 7.26675 9.33366 8.00008 9.33366C8.73341 9.33366 9.33341 8.73366 9.33341 8.00033C9.33341 7.26699 8.73341 6.66699 8.00008 6.66699Z'
        fill={fill}
      />
    </svg>
  )
}
